import produce from 'immer';
import {
	FETCH_NEW_NOTIFICATIONS_FULFILLED,
	FETCH_NOTIFICATIONS,
	FETCH_NOTIFICATIONS_FAILED,
	FETCH_NOTIFICATIONS_FULFILLED,
	SET_RECENTLY_VIEWED_DATE_FULFILLED,
} from '../constants/actions/notificationsActions';
import INotificationsReducer from '../interfaces/reducers/notificationsReducer';

const initialValues: INotificationsReducer = {
	notifications: null,
	currentPage: 1,
	totalCount: 0,
	totalPageCount: 0,
	notificationsLoading: false,
	notificationsError: false,
	recentlyViewedDate: undefined,
	newNotificationsCount: 0,
};

const notificationsReducer = produce((draft: INotificationsReducer, action) => {
	switch (action.type) {
		case FETCH_NOTIFICATIONS: {
			draft.notificationsLoading = true;
			draft.notificationsError = false;
			break;
		}
		case FETCH_NOTIFICATIONS_FULFILLED: {
			draft.notifications = action.payload.results;
			draft.currentPage = action.payload.currentPage;
			draft.totalCount = action.payload.totalCount;
			draft.totalPageCount = action.payload.totalPageCount;
			draft.notificationsLoading = false;
			draft.notificationsError = false;
			break;
		}
		case FETCH_NOTIFICATIONS_FAILED: {
			draft.notificationsLoading = false;
			draft.notificationsError = true;
			break;
		}
		case FETCH_NEW_NOTIFICATIONS_FULFILLED: {
			draft.newNotificationsCount = action.payload;
			break;
		}
		case SET_RECENTLY_VIEWED_DATE_FULFILLED: {
			draft.newNotificationsCount = 0;
			break;
		}
		default:
			break;
	}
}, initialValues);

export default notificationsReducer;
